import React from 'react';
import styles from './AgencyReportsHeaderFilter.module.scss';
import { SFChip, SFDropdownField, SFDropdownFieldOption } from 'sfui';
import { ReportPreFilter } from '../../../../../Models';

const isValueSelected = (
  selected: ReportPreFilter,
  chipLabel: string
): boolean => {
  switch (selected) {
    case 'all':
      return chipLabel === 'ALL';
    case 'cad_rms_contacts':
      return chipLabel === 'CAD/RMS followed by Contact';
    case 'cad_rms':
      return chipLabel === 'CAD/RMS';
    case 'contacts':
      return chipLabel === 'Contacts';
  }
};

export interface AgencyReportsHeaderFilterProps {
  selected?: ReportPreFilter;
  isLoading?: boolean;
  onFilterChange: (selected: ReportPreFilter) => void;
}

export const AgencyReportsHeaderFilter = ({
  selected = 'all',
  isLoading = false,
  onFilterChange
}: AgencyReportsHeaderFilterProps): React.ReactElement<AgencyReportsHeaderFilterProps> => {
  const HEADER_FILTER_OPTIONS: SFDropdownFieldOption[] = React.useMemo(
    () => [
      {
        label: 'ALL',
        onClick: () => onFilterChange('all'),
        disabled: isLoading && selected !== 'all'
      },
      {
        label: 'CAD/RMS followed by Contact',
        onClick: () => onFilterChange('cad_rms_contacts'),
        disabled: isLoading && selected !== 'cad_rms_contacts'
      },
      {
        label: 'CAD/RMS',
        onClick: () => onFilterChange('cad_rms'),
        disabled: isLoading && selected !== 'cad_rms'
      },
      {
        label: 'Contacts',
        onClick: () => onFilterChange('contacts'),
        disabled: isLoading && selected !== 'contacts'
      }
    ],
    [onFilterChange, isLoading, selected]
  );

  return (
    <div className={styles.agencyReportsHeaderFilter}>
      <div className={styles.selectWrapper}>
        <SFDropdownField
          options={HEADER_FILTER_OPTIONS}
          sfColor="blue"
          variant="contained"
          fullWidth={true}
          popperZIndex={2000}
        />
      </div>
      <div className={styles.chipsWrapper}>
        {HEADER_FILTER_OPTIONS.map((option: SFDropdownFieldOption) => {
          return (
            <SFChip
              className={styles.chip}
              key={option.label}
              label={option.label}
              sfColor="primary"
              size="small"
              disabled={option.disabled}
              variant={
                isValueSelected(selected, option.label) ? 'default' : 'outlined'
              }
              onClick={option.onClick}
            />
          );
        })}
      </div>
    </div>
  );
};
